import React, { Fragment } from "react"
import { Box, Typography, useTheme } from "@mui/material"
import styles from "../../Quiz.module.scss"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"

function Question({ question, index, isEdit = false }) {
  const boxStyling = { marginTop: "18px", marginBottom: "18px" }
  const theme = useTheme()

  return (
    <Fragment>
      <Box className={styles.question} sx={!isEdit && boxStyling}>
        <Typography
          sx={{ margin: "0px 0px 4px 52px" }}
          color={theme.palette.secondary.main}
          variant="caption3"
          style={{ opacity: 1 }}
          className={styles.questionHeader}>
          {`${question?.category ?? "-"} ${question?.food_name ? `| ${question?.food_name}` : ""}`}
        </Typography>
        <Box className={styles.questionTitle}>
          <Typography variant="body1Regular">{index + 1}</Typography>
          <ArrowForwardIcon sx={{ marginLeft: "14px" }} />
          <Typography variant="h4" sx={{ marginLeft: "6px" }}>
            {question?.title}
          </Typography>
        </Box>
        {question?.question_type === "2-images" || question?.question_type === "4-images" ? (
          question?.answer?.map((option, index) => (
            <Box
              key={option.id}
              className={`${styles.option} ${option?.is_correct ? styles.optionCorrect : ""}`}>
              <div className={styles.optionNumber}>
                <Typography variant="tag1">{(index + 10).toString(36).toUpperCase()}</Typography>
              </div>
              <Typography
                className={styles.optionName}
                sx={{ marginLeft: "10px" }}
                variant="body2Regular">
                {option?.answer}
              </Typography>
            </Box>
          ))
        ) : question?.question_type === "matching" ? (
          <Box className="d-flex flex-column">
            {question?.match_pairs?.map((pair, index) => (
              <Box key={index} className={`${styles.option}`}>
                <Box className={styles.optionNumber}>
                  <Typography variant="tag1">{(index + 10).toString(36).toUpperCase()}</Typography>
                </Box>
                <Box className="d-flex flex-column gap-1 ps-2">
                  <Typography className={styles.optionName} variant="body2Regular">
                    {pair?.left_text}
                  </Typography>
                  <Typography
                    className={styles.optionName}
                    variant="body2Regular"
                    color={theme.palette.success.main}>
                    {pair?.right_text}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          question?.answer?.map((option, index) => (
            <Box
              key={option.id}
              className={`${styles.option} ${option?.is_correct ? styles.optionCorrect : ""}`}>
              <div className={styles.optionNumber}>
                <Typography variant="tag1">{(index + 10).toString(36).toUpperCase()}</Typography>
              </div>
              <Typography
                className={styles.optionName}
                variant="body2Regular"
                sx={{ marginLeft: "10px" }}>
                {option?.answer}
              </Typography>
            </Box>
          ))
        )}
      </Box>
    </Fragment>
  )
}

export default Question
